<template>
  <div class="table-container lapi__log">
    <table class="table is-bordered is-striped is-narrow is-hoverable">
      <thead>
      <tr>
        <th>OrdenNew</th>
        <th>Usuario</th>
        <th>Fecha</th>
        <th>Forma</th>
        <th>Metodo</th>
        <th>Mensaje</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in data">
        <td>{{ item.order_new }}</td>
        <td>{{ item.user }}</td>
        <td>{{ item.date }}</td>
        <td>{{ item.form }}</td>
        <td>{{ item.method }}</td>
        <td>
          <a :href="item.message" v-if="item.message.toString().startsWith('http')"
             target="_blank">{{ item.message }}</a>
          <a @click="handleWhatsappHistory(item.message)" v-else-if="item.form.toString()==='meta-whatsapp'"
             target="_blank">{{ item.message }}</a>
          <span v-else>{{ item.message }}</span>
        </td>
      </tr>
      </tbody>
    </table>
    <b-modal v-model="showMetaLogModal">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">Log de Meta</p>
            </div>
          </div>

          <div class="content">
            <b-collapse
              v-for="(item, index) in metaLog" :key="index"
              :open="false"
              class="card" animation="slide"  :aria-id="`contentIdForA11y3_${index}`">
              <template #trigger="props">
                <div
                  class="card-header"
                  role="button"
                  :aria-controls="`contentIdForA11y3_${index}`"
                  :aria-expanded="props.open"
                >
                  <p class="card-header-title">{{item.createdAt}} - {{item.message | metaStatus}}</p>
                  <a class="card-header-icon">
                    <b-icon :icon="props.open ? 'caret-down' : 'caret-up'">
                    </b-icon>
                  </a>
                </div>
              </template>

              <div class="card-content">
                <div class="content">
                  <code>
                    {{item.message}}
                  </code>

                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "OrderHistory",
  props: {
    order: {}
  },
  data() {
    return {
      data: [],
      apiUrl: "lapi-log",
      metaLog: [],
      showMetaLogModal: false
    };
  },
  mounted() {
    if (this.order.id) {
      this.prepareData();
    }
  },
  watch: {
    order: {
      handler() {
        if (this.order.id) {
          this.prepareData();
        }
      },
      deep: true
    }
  },
  methods: {
    prepareData() {
      this.getAll({
        order: this.order.order_new
      }).then(({ data }) => {
        this.data = data;
      }).catch(() => {

      }).finally(() => {

      });
    },
    handleWhatsappHistory(token) {
      this.$loader.show();
      this.$http.get(`/meta-whatsapp/history/${token}`).then(({ data }) => {
        this.showMetaLogModal = true;
        this.metaLog = data.data;
      }).catch(() => {
        this.$toast.error("Error al obtener el historial de WhatsApp");
      }).finally(() => {
        this.$loader.hide();
      });
    }
  }
};
</script>

<style scoped>
.lapi__log {
  height: 300px;
  overflow: auto;
}
code {
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
</style>
